import Dropzone from "react-dropzone";
import React, { useState } from "react";

// Description:
// This component is an upgrade of the Traec - react DropzoneButton.This version uses React hooks and renders a spinner when a user selects a file to upload until that file is processed by the browser.
// How to use:
// 1. create a loading state in the parent component
// 2. create 2 functions, 1 will set the loading state to true the other to false
// 3. create a files state
// 4. create an ondrop function which takes 'files' as an argument and sets the files state to the files argument

export const DropzoneButton = (props) => {
  let { selectAreaText, isUploadingFile, selectedFiles, onDrop, extra_className, uploadedCount, totalCount } = props;

  selectAreaText = selectAreaText || "Click or drop here to add files";

  return (
    <div>
      <Dropzone onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => {
          if (isUploadingFile) {
            let totalFiles = Number.isInteger(totalCount) ? totalCount : selectedFiles?.length || 0;
            let uploadedFiles = Number.isInteger(uploadedCount) ? uploadedCount : 0;
            return (
              <>
                <span className="mr-2">Uploading {uploadedFiles}/{totalFiles} files...</span>
                <span className="spinner-border spinner-border-sm px-1" role="status"></span>
              </>
            );
          }
          return (
            <div
              {...getRootProps()}
              className={`btn btn-sm btn-outline-secondary ${extra_className} ${isUploadingFile ? " disabled" : ""}`}
              style={{ cursor: "pointer" }}
            >
              <input {...getInputProps()} />
              {selectAreaText}
            </div>
          );
        }}
      </Dropzone>
    </div>
  );
};
